import { render, staticRenderFns } from "./vncPage.vue?vue&type=template&id=61e6a8ac&scoped=true&"
import script from "./vncPage.vue?vue&type=script&lang=js&"
export * from "./vncPage.vue?vue&type=script&lang=js&"
import style0 from "./vncPage.vue?vue&type=style&index=0&id=61e6a8ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e6a8ac",
  null
  
)

export default component.exports